import React from "react";

export default function About() {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="section bg-[color:var(--bg)] relative"
    >
      <div className="max-w-[1400px] mx-auto flex flex-col gap-10 lg:grid lg:grid-cols-12">
        <div className="col-span-12 lg:col-span-5">
          <div className="flex items-center gap-3 mb-6 reveal">
            <span className="diamond-divider" />
            <span className="overline">About Us</span>
          </div>
          <h2 className="reveal font-display tracking-tight text-neutral-900 text-4xl md:text-5xl leading-[1.05]">
            Every vehicle deserves <em className="font-light italic text-neutral-600">premium</em> care.
          </h2>
          <div className="mt-8 hairline" />
          <div className="mt-8 space-y-4 text-neutral-600 leading-relaxed text-[15px]">
            <p>
              At Deluxe Diamond Detailing, we are passionate about delivering
              exceptional results using professional-grade equipment, safe
              detailing techniques, and industry-leading products.
            </p>
            <p>
              Whether it&apos;s your daily driver, performance car, family SUV,
              luxury vehicle or weekend pride and joy — we treat every vehicle
              as if it were our own.
            </p>
          </div>

          <div className="mt-10 grid grid-cols-3 gap-4 max-w-md">
            {[
              { k: "Precision", n: "01" },
              { k: "Protection", n: "02" },
              { k: "Perfection", n: "03" },
            ].map((t) => (
              <div
                key={t.k}
                data-testid={`about-pillar-${t.k.toLowerCase()}`}
                className="card p-5"
              >
                <div className="overline">{t.n}</div>
                <div className="font-display text-neutral-900 text-lg font-semibold mt-2">
                  {t.k}
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="col-span-12 lg:col-span-7 reveal">
          <div className="relative aspect-[4/5] lg:aspect-[5/6] overflow-hidden">
            <img
              src="https://images.pexels.com/photos/14231701/pexels-photo-14231701.jpeg"
              alt="Detailer polishing a luxury car"
              className="w-full h-full object-cover"
              loading="lazy"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent" />
            <div className="absolute bottom-6 left-6 right-6 p-6 backdrop-blur-xl bg-white/80 border border-neutral-200">
              <div className="overline">Our mission</div>
              <p className="font-display text-neutral-900 text-lg md:text-xl mt-2 leading-snug">
                Restore. Protect. Maintain — every vehicle to the highest
                standard.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
